import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import { getDefaultValidator } from '../../formUtils/stringValidator'

function StatesSelectField({ states, nameField, fieldType, selectData }) {
  return (
    <Field
      as="select"
      name={nameField}
      className="form__input"
      validate={getDefaultValidator(selectData, fieldType)}
      defaultValue="DEFAULT"
    >
      <option value="DEFAULT" disabled>
        {' '}
      </option>
      {states.map(state => (
        <option value={state} key={state}>
          {state}
        </option>
      ))}
    </Field>
  )
}

StatesSelectField.propTypes = {
  states: PropTypes.array.isRequired,
  nameField: PropTypes.string.isRequired,
  fieldType: PropTypes.string.isRequired,
  selectData: PropTypes.object.isRequired
}

export default StatesSelectField
